<template>
  <viewer-form :can-edit="true" :can-back="false" @submit.prevent="toEditor">
    <text-browse-item label="氏名" :value="name" />
    <text-browse-item label="氏名（カナ）" :value="nameKana" />
    <switch-browse-item label="管理者" :checked="isSupervisor" />
    <text-browse-item label="メールアドレス" :value="email" />
    <switch-browse-item label="２段階認証" :checked="useTwoStepAuthentication" />
    <textarea-browse-item label="連絡先" :value="contact" />
    <text-browse-item label="店舗名" :value="office" />
    <text-browse-item label="部署名" :value="department" />
  </viewer-form>
</template>

<script>
import {mapState} from 'vuex';
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent'
import ViewerForm from "@/views/templates/forms/ViewerForm";
import TextBrowseItem from "@/views/molecules/browseItems/TextBrowseItem";
import SwitchBrowseItem from '@/views/molecules/browseItems/SwitchBrowseItem'
import TextareaBrowseItem from "@/views/molecules/browseItems/TextareaBrowseItem";

export default {
  name: "AccountViewer",
  components: {
    ViewerForm,
    TextBrowseItem,
    SwitchBrowseItem,
    TextareaBrowseItem,
  },
  mixins: [AddonLoadPageEvent],
  computed: {
    ...mapState('account_form', {
      name: state => state.data.name,
      nameKana: state => state.data.name_kana,
      isSupervisor: state => state.data.is_supervisor,
      email: state => state.data.email,
      contact: state => state.data.contact,
      office: state => state.data.office,
      department: state => state.data.department,
      useTwoStepAuthentication: state => state.data.use_two_step_authentication,
    }),
  },
  methods: {
    loadPage() {
      return this.$store.dispatch('account_form/load').then(() => {
        this.$root.showFlashMessage();
      }).catch(() => this.$root.failApi());
    },
    toEditor() {
      this.$router.push({name: 'AccountEditor'});
    },
  }
}
</script>
